import './common.less';
import * as echarts from 'echarts';
import type { EChartsExtensionInstallRegisters } from 'echarts';
import { use, graphic } from 'echarts/core';
import { componentExtensions, chartExtensions, graphicExtensions } from './extension';
import { registerTheme } from './core/theme';
import presetThemes from './theme';

// extension
use([...componentExtensions, ...chartExtensions] as unknown as ((
  registers: EChartsExtensionInstallRegisters
) => void)[]);

graphicExtensions.forEach(extInstall => extInstall(graphic));

// theme
presetThemes.forEach(theme => registerTheme(theme.name, theme.parsers));

export { version as VERSION } from '../package.json';

export { init } from './standardChart';
export * as helper from './helper';
export * as util from './util';

// 3rd
export { echarts };

// types
export * from './util/type';
